import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getAccessorialById } from "@tKgpco/Services/AccessorialsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { Accessorial } from "@tKgpco/Store/Data/Accessorials/AccessorialsState";

type Parameters = { id: string } & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, Accessorial>;

export const BeginLoadAccessorial: HandlerType = props => {
    props.dispatch({ type: "Custom/EditAccessorials/BeginLoad" });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getAccessorialById(props.parameter.id);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const CompleteLoadAccessorial: HandlerType = props => {
    props.dispatch({
        type: "Custom/EditAccessorials/CompleteLoad",
        accessorial: props.apiResult,
    });
};

export const chain = [BeginLoadAccessorial, RequestDataFromApi, CompleteLoadAccessorial];

const loadAccessorial = createHandlerChainRunner(chain, "CustomLoadAccessorial");
export default loadAccessorial;
